/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース位置情報
 * @export
 * @interface PressReleaseLocation
 */
export interface PressReleaseLocation {
    /**
     * 都道府県id
     * @type {string}
     * @memberof PressReleaseLocation
     */
    prefId?: string | null;
    /**
     * 市町村id
     * @type {string}
     * @memberof PressReleaseLocation
     */
    cityId?: string | null;
    /**
     * 住所
     * @type {string}
     * @memberof PressReleaseLocation
     */
    address?: string | null;
    /**
     * 位置情報カテゴリid
     * @type {number}
     * @memberof PressReleaseLocation
     */
    locationCateId: number;
}

export function PressReleaseLocationFromJSON(json: any): PressReleaseLocation {
    return PressReleaseLocationFromJSONTyped(json, false);
}

export function PressReleaseLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefId': !exists(json, 'pref_id') ? undefined : json['pref_id'],
        'cityId': !exists(json, 'city_id') ? undefined : json['city_id'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'locationCateId': json['location_cate_id'],
    };
}

export function PressReleaseLocationToJSON(value?: PressReleaseLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pref_id': value.prefId,
        'city_id': value.cityId,
        'address': value.address,
        'location_cate_id': value.locationCateId,
    };
}

